import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-general-half-heart-icon',
  templateUrl: './general-half-heart.component.html'
})
export class GeneralHalfHeartComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
